module.exports = __webpack_public_path__ + "img/MiniTips.5844c65e.png";